import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { LoginService } from '../services/login/login';
import { UserStateService } from '../services/user-state/user-state';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const loginService = inject(LoginService);
  const userStateService = inject(UserStateService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      const excludedUrls = ['/login', '/refresh_token'];
      const isExcluded = excludedUrls.some((url) => req.url.includes(url));

      if (error.status === 401 && !isExcluded) {
          return loginService.refreshToken().pipe(
          switchMap(() => {
             return next(req);
          }),
          catchError((refreshError) => {
           userStateService.clearUser();
            localStorage.clear();
            router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
